import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, MessageCircle, Phone, ExternalLink } from "lucide-react";

const phone = "+91 75874 96155";
const whatsapp = "https://wa.me/917587496155";

export const ContactPage = () => (
  <main className="min-h-screen bg-background text-foreground">
    <section className="py-16 md:py-20 border-b border-border/40">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="text-xs font-mono uppercase tracking-wider text-emerald-400">Contact Kian Technologies</span>
        <h1 className="mt-3 text-4xl sm:text-5xl font-extrabold tracking-tight">Let's Connect</h1>
        <p className="mt-4 text-sm sm:text-base text-muted-foreground max-w-2xl mx-auto">Have a question about the Masterclass, registration, student access or training? Reach out to the Kian Technologies team.</p>
      </div>
    </section>

    <section className="py-14">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-5">
        <a href="mailto:hello@kiantechnologies.in" className="p-6 rounded-xl bg-card border border-border hover:border-emerald-500/40 transition-colors group">
          <Mail className="w-5 h-5 text-emerald-400" />
          <h2 className="mt-4 font-semibold">Email</h2>
          <p className="mt-2 text-sm text-muted-foreground group-hover:text-foreground transition-colors">hello@kiantechnologies.in</p>
        </a>
        <a href={whatsapp} target="_blank" rel="noopener noreferrer" className="p-6 rounded-xl bg-card border border-border hover:border-emerald-500/40 transition-colors group">
          <MessageCircle className="w-5 h-5 text-emerald-400" />
          <h2 className="mt-4 font-semibold">WhatsApp</h2>
          <p className="mt-2 text-sm text-muted-foreground group-hover:text-foreground transition-colors">{phone}</p>
        </a>
        <div className="p-6 rounded-xl bg-card border border-border">
          <MapPin className="w-5 h-5 text-emerald-400" />
          <h2 className="mt-4 font-semibold">Training Center</h2>
          <p className="mt-2 text-sm text-muted-foreground leading-relaxed">Smriti Nagar, Bhilai, Durg (C.G.) 490020</p>
        </div>
      </div>
    </section>

    <section className="pb-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-6">
        <div className="p-7 rounded-2xl bg-card border border-border">
          <div className="flex items-center gap-2 text-emerald-400"><Phone className="w-4 h-4" /><span className="font-mono text-xs uppercase">Quick Help</span></div>
          <h2 className="text-2xl font-bold mt-3">Need help with your Masterclass application?</h2>
          <p className="mt-3 text-sm text-muted-foreground leading-relaxed">For registration, approval, activation or portal-related questions, contact us using email or WhatsApp. Please mention your application number or student ID when available.</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href={whatsapp} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-mono">WhatsApp <ExternalLink className="w-3.5 h-3.5" /></a>
            <a href="mailto:hello@kiantechnologies.in" className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-border hover:bg-muted text-sm font-mono">Email Us</a>
          </div>
        </div>
        <div className="p-7 rounded-2xl bg-muted/20 border border-border">
  <div className="flex items-center gap-2 text-cyan-400 mb-3">
    <MapPin className="w-4 h-4" />
    <span className="font-mono text-xs uppercase">Location</span>
  </div>
  
  <div className="w-full h-56 rounded-xl overflow-hidden border border-border">
    <iframe
      title="Kian Technologies Location"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.45962652577!2d81.31564851159875!3d21.213614981320983!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a293dbb95c478ab%3A0xd50ec49f3064301!2sKian%20Technologies!5e0!3m2!1sen!2sin!4v1788839353300!5m2!1sen!2sin"
      width="100%"
      height="100%"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="strict-origin-when-cross-origin"
    ></iframe>
  </div>
</div>
      </div>
    </section>
  </main>
);
